import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SlideUpDown } from "../../../services/script"
import "./footer.css"
import { Link } from 'react-router-dom';
import ScrollToTop from '../../pages/scroll_to_top';
import {
    FaFacebookF, FaInstagram, FaTiktok, FaYoutube
} from 'react-icons/fa';
import footerLogoImg from '../../../assets/images/footerLogo.png';

class FooterFour extends Component {
    constructor(props) {
        super(props);
        this.state = { email: '' };
    }

    componentDidMount() {
        var contentwidth = window.innerWidth;
        if (contentwidth < 750) {
            SlideUpDown('slide-up');
        } else {
            var elems = document.querySelectorAll(".footer-title");
            [].forEach.call(elems, function (elemt) {
                let el = elemt.nextElementSibling;
                el.style = "display: block";
            });
        }
    }

    render() {
        const { sociallinks, contactDetails, categories, appconfigs, footerIcons } = this.props;

        const colorCodes = localStorage.getItem("color_theme");
        let parsedColorCodes = JSON.parse(colorCodes);
        let appconfig = parsedColorCodes && parsedColorCodes !== null ? parsedColorCodes : appconfigs;

        const shopName = parsedColorCodes?.shop_name || appconfigs?.shop_name || '';
        const email = contactDetails?.data?.email || '';

        const fbUrl = contactDetails?.data?.facebook_page || '/#';
        const igUrl = contactDetails?.data?.instagram_page || '/#';
        const ttUrl = contactDetails?.data?.twitter_page || 'https://www.tiktok.com/@shanzbyshanzay';
        const ytUrl = contactDetails?.data?.youtube_page || '/#';

        return (
            <footer className="ftr-root">
                <ScrollToTop />

                {/* ── Main columns ── */}
                <div className="ftr-body">
                    <div className="ftr-grid">

                        {/* Col 1 — Logo & brand */}
                        <div className="ftr-col ftr-col--brand">
                            <Link to={`${process.env.PUBLIC_URL}/`} className="ftr-logo-link" aria-label="Home">
                                <img
                                    src={footerLogoImg}
                                    alt={shopName || 'Shanz by Shanzay'}
                                    className="ftr-logo-img"
                                />
                            </Link>
                        </div>

                        {/* Col 2 — Shop */}
                        <div className="ftr-col">
                            <h4 className="ftr-col-title">SHOP</h4>
                            <ul className="ftr-col-links">
                                {/* <li><Link to={`${process.env.PUBLIC_URL}/products`}>New Arrivals</Link></li> */}
                                {categories && categories.length !== 0
                                    ? (categories.length < 5
                                        ? categories
                                        : categories.slice(0, 5)
                                    ).map((m, i) => (
                                        <li key={i}>
                                            <Link
                                                to={{
                                                    pathname: `/products/${m.name.replace(/\s+/g, '-')}-${m.id}`,
                                                    state: { categories: m },
                                                }}
                                            >
                                                {m.name}
                                            </Link>
                                        </li>
                                    ))
                                    : null
                                }
                            </ul>
                        </div>

                        {/* Col 3 — Customer Care */}
                        <div className="ftr-col">
                            <h4 className="ftr-col-title">CUSTOMER CARE</h4>
                            <ul className="ftr-col-links">
                                {appconfig?.nav_contact === 1 && (
                                    <li><Link to={`${process.env.PUBLIC_URL}/contact`}>Contact</Link></li>
                                )}
                                <li><Link to={`${process.env.PUBLIC_URL}/shipping-policy`}>Shipping</Link></li>
                                <li><Link to={`${process.env.PUBLIC_URL}/privacy-policy`}>Returns &amp; Exchanges</Link></li>
                                <li><Link to={`${process.env.PUBLIC_URL}/faqs`}>FAQs</Link></li>
                            </ul>
                        </div>

                        {/* Col 4 — Stay Connected */}
                        <div className="ftr-col ftr-col--connect">
                            <h4 className="ftr-col-title">STAY CONNECTED</h4>
                            <p className="ftr-connect-desc">
                                Be the first to know about new arrivals,<br />
                                exclusive offers and more.
                            </p>

                            {/* Email subscribe row */}
                            <div className="ftr-subscribe-row">
                                <input
                                    type="email"
                                    placeholder="Your email address"
                                    value={this.state.email}
                                    onChange={(e) => this.setState({ email: e.target.value })}
                                    className="ftr-email-input"
                                    aria-label="Email address"
                                />
                                <button
                                    className="ftr-subscribe-btn"
                                    aria-label="Subscribe"
                                    onClick={() => this.setState({ email: '' })}
                                >
                                    &#8594;
                                </button>
                            </div>

                            {/* Social icons */}
                            <div className="ftr-social-row">
                                {appconfig?.footer_follow_us === 1 && sociallinks?.data ? (
                                    <>
                                        {sociallinks.data[1]?.is_active === 1 && (
                                            <a href={igUrl} target="_blank" rel="noopener noreferrer" className="ftr-social-icon" aria-label="Instagram">
                                                <FaInstagram />
                                            </a>
                                        )}
                                        {sociallinks.data[0]?.is_active === 1 && (
                                            <a href={fbUrl} target="_blank" rel="noopener noreferrer" className="ftr-social-icon" aria-label="Facebook">
                                                <FaFacebookF />
                                            </a>
                                        )}
                                        {sociallinks.data[2]?.is_active === 1 && (
                                            <a href={ttUrl} target="_blank" rel="noopener noreferrer" className="ftr-social-icon" aria-label="TikTok">
                                                <FaTiktok />
                                            </a>
                                        )}
                                        <a href={ytUrl} target="_blank" rel="noopener noreferrer" className="ftr-social-icon" aria-label="YouTube">
                                            <FaYoutube />
                                        </a>
                                    </>
                                ) : (
                                    <>
                                        <a href={igUrl} target="_blank" rel="noopener noreferrer" className="ftr-social-icon" aria-label="Instagram"><FaInstagram /></a>
                                        <a href={fbUrl} target="_blank" rel="noopener noreferrer" className="ftr-social-icon" aria-label="Facebook"><FaFacebookF /></a>
                                        <a href={ttUrl} target="_blank" rel="noopener noreferrer" className="ftr-social-icon" aria-label="TikTok"><FaTiktok /></a>
                                        <a href={ytUrl} target="_blank" rel="noopener noreferrer" className="ftr-social-icon" aria-label="YouTube"><FaYoutube /></a>
                                    </>
                                )}
                            </div>
                        </div>

                    </div>
                </div>

                {/* ── Bottom bar ── */}
                <div className="ftr-bottom">
                    <span className="ftr-bottom-copy">
                        &copy; {new Date().getFullYear()} {shopName}. All rights reserved.
                    </span>
                    <nav className="ftr-bottom-links" aria-label="Footer legal links">
                        <Link to={`${process.env.PUBLIC_URL}/privacy-policy`}>Return &amp; Exchange Policy</Link>
                        <span className="ftr-bottom-sep" aria-hidden="true">|</span>
                        <Link to={`${process.env.PUBLIC_URL}/shipping-policy`}>Shipping Policy</Link>
                        <span className="ftr-bottom-sep" aria-hidden="true">|</span>
                        <Link to={`${process.env.PUBLIC_URL}/terms`}>Terms &amp; Conditions</Link>
                        {appconfig?.nav_contact === 1 && (
                            <>
                                <span className="ftr-bottom-sep" aria-hidden="true">|</span>
                                <Link to={`${process.env.PUBLIC_URL}/contact`}>Contact</Link>
                            </>
                        )}
                    </nav>
                </div>
            </footer>
        );
    }
}

const mapStateToProps = (state) => ({
    sociallinks: state.contactDetails.socialLinks,
    contactDetails: state.contactDetails.contactDetails,
    categories: state.data.menu,
    appconfigs: state?.user?.config ? state.user.config : '',
    footerIcons: state?.user?.footerIcons,
});

export default connect(mapStateToProps)(FooterFour);
